// extracted by mini-css-extract-plugin
export var mapTextbox = "map-textbox-module--map-textbox--VHNjV";
export var headline = "map-textbox-module--headline--1Pxez";
export var imageContainer = "map-textbox-module--image-container--1RySa";